import React, { useState } from 'react';
import type { ViewType } from './types';
import { Sidebar } from './components/layout/Sidebar';
import { DashboardPage } from './components/dashboard/DashboardPage';
import { GoalConfigPage } from './components/goals/GoalConfigPage';
import { HistoryPage } from './components/history/HistoryPage';
export function App() {
  const [activeView, setActiveView] = useState<ViewType>('dashboard');
  return <div className="flex min-h-screen bg-gray-100" data-id="element-0">
      <Sidebar activeView={activeView} onViewChange={setActiveView} data-id="element-1" />

      <main className="flex-1 ml-60 min-h-screen" data-id="element-2">
        {activeView === 'dashboard' && <DashboardPage data-id="element-3" />}
        {activeView === 'goals' && <GoalConfigPage data-id="element-4" />}
        {activeView === 'history' && <HistoryPage data-id="element-5" />}
      </main>
    </div>;
}